import React, { useEffect, useState } from "react";
import {
  Empty,
  Modal,
  InputNumber,
  Switch,
  Select,
  message,
  Drawer,
} from "antd";
import ProcessData from "./ProcessData";
import { isHaveVal } from "../../utils/common";
import { stationApi } from "../../api/newApi";
import { MenuUnfoldOutlined } from "@ant-design/icons";
import "./index.scss";

const StationProcess = ({ previewProcessData = {}, dataShow = true }) => {
  const [processList, setProcessList] = useState([]);
  const [linePath, setLinePath] = useState([]);
  const [title, setTitle] = useState("");
  const [visible, setVisilbe] = useState(false);
  const [attrList, setAttrList] = useState([]);
  const [open, setOpen] = useState(false);
  const [processFlowDeviceDiyDTOList, setProcessFlowDeviceDiyDTOList] =
    useState([]);

  useEffect(() => {
    if (previewProcessData.processFlowUnitDTOList) {
      const list = [];
      let paths = [];
      previewProcessData.processFlowUnitDTOList &&
        previewProcessData.processFlowUnitDTOList.forEach((item) => {
          if (item.linePath && item.linePath.length > 0) {
            paths = [...paths, ...item.linePath];
          }
          list.push({
            ...item,
            show: false,
          });
        });
      paths.forEach((item) => {
        const w = Math.sqrt(
          Math.pow(item.endX - item.startX, 2) +
            Math.pow(item.endY - item.startY, 2)
        );
        const angle =
          Math.atan2(item.endY - item.startY, item.endX - item.startX) *
          (180 / Math.PI);
        item.width = w;
        item.angle = angle;
      });
      list.forEach((obj) => {
        const diyAttrList = obj.diyAttrList ? [...obj.diyAttrList] : [];
        diyAttrList.forEach((item) => {
          if (item.type == 3) {
            const enumMap = item.enumMap ? item.enumMap.split(",") : [];
            const arr = [];
            enumMap.forEach((subItem, subIndex) => {
              if (subIndex % 2 == 0 && subItem) {
                const val = enumMap[subIndex + 1] || "";
                arr.push({
                  lable: subItem,
                  value: val,
                });
              }
            });
            item.enumMapArr = arr;
            item.value = isHaveVal(item.value);
          }
        });
      });
      setLinePath(paths);
      setProcessList(list);
      setProcessFlowDeviceDiyDTOList(
        previewProcessData.processFlowDeviceDiyDTOList
          ? previewProcessData.processFlowDeviceDiyDTOList
          : []
      );
    }
  }, [previewProcessData]);

  const closePane = (index) => {
    processList[index].show = false;
    setProcessList(() => {
      return [...processList];
    });
  };

  const handleVisble = (index) => {
    const info = processList[index];
    const { diyAttrList, processunitName } = info;
    setAttrList(diyAttrList);
    setTitle(processunitName);
    setVisilbe(true);
  };

  const showAttr = (index) => {
    if (!dataShow) return;
    processList[index].show = true;
    setProcessList(() => {
      return [...processList];
    });
  };

  const sendInstructions = (obj, value) => {
    const params = {
      devId: previewProcessData.iotGatewayNum,
      name: `${obj.attrName}指令下发`,
      code: obj.attrCode,
      value,
    };
    if (obj.type == 1) {
      params.value = value ? 1 : 0;
    }
    stationApi.devicePut(params).then((res) => {
      if (res.status !== "0") return;
      message.success("指令下发成功");
    });
  };

  return previewProcessData.processFlowUnitDTOList &&
    previewProcessData.processFlowUnitDTOList.length > 0 ? (
    <>
      <div
        className="station-process"
        style={{
          width: previewProcessData.canvasWidth,
          height: previewProcessData.canvasHeight,
          backgroundImage: `url(${previewProcessData.canvasBg})`,
        }}
      >
        {linePath.map((item, index) => {
          return (
            <div
              key={index}
              className="process-line"
              style={{
                left: item.startX,
                top: item.startY,
                width: item.width,
                transform: `rotate(${item.angle}deg)`,
                transformOrigin: "left top",
              }}
            >
              <div className="light"></div>
              <div className="water"></div>
            </div>
          );
        })}
        {processList.map((item, index) => {
          return (
            <div
              className="process-item"
              key={item.processunitId}
              style={{
                left: item.posX,
                top: item.posY,
                width: item.width,
                height: item.height,
              }}
            >
              <img src={item.unitPic} />
              <div
                className="process-name"
                style={{ cursor: dataShow ? "pointer" : "auto" }}
                onClick={() => showAttr(index)}
              >
                {item.processunitName}
              </div>
              {dataShow && item.show && (
                <ProcessData
                  devicesData={item}
                  closePane={() => closePane(index)}
                  handleVisble={() => handleVisble(index)}
                  offset={{ top: item.height }}
                />
              )}
            </div>
          );
        })}
        {processFlowDeviceDiyDTOList.map((item) => {
          return (
            <div
              className="custom-html"
              key={item.id}
              style={{
                position: "absolute",
                width: item.width,
                height: item.height,
                left: item.posX,
                top: item.posY,
              }}
            >
              {item.isShowName == 1 && <div className="h">{item.attrName}</div>}
              {item.type == 1 && (
                <div className={item.value == 1 ? "v success" : "v error"}>
                  {item.value == 1 ? "启动" : "停止"}
                </div>
              )}
              {item.type == 2 && (
                <div className="v" style={{ transform: "scale(0.9)" }}>
                  {item.value + item.unit}
                </div>
              )}
              {item.type == 3 && (
                <div className="v" style={{ transform: "scale(0.9)" }}>
                  {item.value}
                </div>
              )}
            </div>
          );
        })}
        <Modal
          title={title}
          className="config-modal device-modal"
          destroyOnClose
          open={visible}
          onOk={() => setVisilbe(false)}
          onCancel={() => setVisilbe(false)}
        >
          <div className="config-con">
            {attrList.map((item) => {
              return (
                <div
                  className="config-item"
                  key={item.id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "100%",
                    height: "auto",
                  }}
                >
                  <div className="config-title" style={{ flex: 3, border: 0 }}>
                    <span style={{ textAlign: "left", padding: "0 20px" }}>
                      {item.attrName}
                      {item.unit ? `(${item.unit})` : ""}
                    </span>
                  </div>
                  <div className="con" style={{ flex: 1 }}>
                    {item.type == 1 && (
                      <Switch
                        size="default"
                        checkedChildren="启动"
                        unCheckedChildren="停止"
                        defaultChecked={item.defaultValue == 1}
                        onChange={(e) => sendInstructions(item, e)}
                      />
                    )}
                    {item.type == 2 && (
                      <InputNumber
                        className="con-input-number"
                        defaultValue={item.value * 1}
                        onBlur={(e) => sendInstructions(item, e.target.value)}
                      />
                    )}
                    {item.type == 3 && (
                      <Select
                        className="con-select"
                        defaultValue={item.value}
                        placeholder="请选择"
                        onChange={(e) => sendInstructions(item, e)}
                      >
                        {item.enumMapArr.map((subItem) => {
                          return (
                            <Select.Option
                              key={subItem.value}
                              value={subItem.value}
                            >
                              {subItem.value}
                            </Select.Option>
                          );
                        })}
                      </Select>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </Modal>
      </div>
      {dataShow && (
        <div
          className="process-expand-switch"
          onClick={() => setOpen(!open)}
          style={{ right: open ? 378 : 0 }}
        >
          <MenuUnfoldOutlined />
          {open ? (
            <>
              <span>收</span>
              <span>缩</span>
            </>
          ) : (
            <>
              <span>展</span>
              <span>开</span>
            </>
          )}
        </div>
      )}
      <Drawer
        title="数据展示"
        placement="right"
        onClose={() => setOpen(false)}
        open={open}
      >
        <div className="data-pane">
          {processList.map((item) => {
            return item.diyAttrList && item.diyAttrList.length > 0 ? (
              <div className="data-pane-item" key={item.processunitId}>
                <div className="data-pane-title">{item.processunitName}</div>
                <div className="data-pane-content">
                  {item.diyAttrList.map((subItem) => {
                    return (
                      <div className="data-pane-sub" key={subItem.id}>
                        <div className="data-pane-sub-label">
                          {subItem.attrName}
                        </div>
                        {subItem.type == 1 && (
                          <div
                            className={
                              subItem.value == 1
                                ? "data-pane-sub-ctx success"
                                : "data-pane-sub-ctx error"
                            }
                          >
                            {subItem.value == 1 ? "启动" : "停止"}
                          </div>
                        )}
                        {subItem.type == 2 && (
                          <div className="data-pane-sub-ctx">
                            {subItem.value}
                            <span>{subItem.unit}</span>
                          </div>
                        )}
                        {subItem.type == 3 && (
                          <div className="data-pane-sub-ctx">
                            {subItem.value}
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              ""
            );
          })}
        </div>
      </Drawer>
    </>
  ) : (
    <Empty
      style={{ margin: "200px auto", color: "#fff" }}
      description="暂无工艺流程图"
    />
  );
};

export default StationProcess;
